import React, { useState, useEffect } from "react";
import styles from "./styles/App.module.css";
import CreatorDashboard from "./components/CreatorDashboard";
import ValidatorDashboard from "./components/ValidatorDashboard";
import PublicDashboard from "./components/PublicDashboard";
import VerifyDocumentModal from "./components/VerifyDocumentModal";
//import logo from "./PMRDA_Logo.webp"; // 👈 place your logo in src folder
import logo from "./logo11.webp"; // 👈 place your logo in src folder


export default function App() {
  const [activeNode, setActiveNode] = useState("public");
  const [showVerifyModal, setShowVerifyModal] = useState(false);
useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // optional (use "auto" if you want instant)
  });
}, [activeNode]);
  const handleVerifyClick = () => {
    setShowVerifyModal(true);
  };

  return (
    <div className={styles.container}>
      {/* 🔹 Header with logo and navigation */}
      <header className={styles.header}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="PMRDA Logo" className={styles.logo} />
          <div className={styles.logoText}>
            <h1 className={styles.logoTitle}>SANGLI MIRAJ AND KUPWAD CITY MUNICIPAL CORPORATION</h1>
            <p className={styles.logoSubtitle}>GOVERNMENT OF MAHARASHTRA</p>
          </div>
        </div>

        {/* <h1 className={styles.headerH1}>TDR Blockchain Dashboard</h1> */}

        <nav className={styles.nav}>
          <button onClick={handleVerifyClick}>Verify Document</button>
          <button onClick={() => setActiveNode("public")}>Public</button>
          {/* Uncomment below if needed */}
          {/* <button onClick={() => setActiveNode("creator")}>Creator</button>
          <button onClick={() => setActiveNode("validator")}>Validator</button> */}
        </nav>
      </header>

      {/* 🔹 Main Dashboard Area */}
      <main className={styles.main}>
        {activeNode === "creator" && <CreatorDashboard />}
        {activeNode === "validator" && <ValidatorDashboard />}
        {activeNode === "public" && <PublicDashboard />}
      </main>

      {showVerifyModal && (
        <VerifyDocumentModal onClose={() => setShowVerifyModal(false)} />
      )}
    </div>
  );
}
